import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import Popover, { ArrowContainer } from "react-tiny-popover";

const InlineTerm = ({ term }) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = (event) => {
    event.preventDefault();
    setOpen(!open);
  };

  const Definition = ({ position, targetRect, popoverRect }) => {
    return (
      <ArrowContainer
        position={position}
        targetRect={targetRect}
        popoverRect={popoverRect}
        arrowColor={"#404040"}
      >
        <p className="Tooltip-text" role="alert" aria-live="polite">
          {term.definition}
        </p>
      </ArrowContainer>
    );
  };

  return (
    <Popover
      isOpen={open}
      position={["top", "right", "bottom", "left"]}
      onClickOutside={() => setOpen(false)}
      content={({ position, targetRect, popoverRect }) => (
        <Definition
          position={position}
          targetRect={targetRect}
          popoverRect={popoverRect}
        />
      )}
    >
      <span className="Tooltip">
        <a
          href="#"
          role="button"
          className={`Tooltip-toggle ${open ? "-active" : ""}`}
          onClick={(event) => toggleOpen(event)}
        >
          {term.title}
        </a>
      </span>
    </Popover>
  );
};

InlineTerm.propTypes = {
  term: PropTypes.object.isRequired,
};

export default InlineTerm;
